import { HorizontalBar } from "vue-chartjs";
import "chartjs-plugin-datalabels";
import moment from "moment";

export default {
  extends: HorizontalBar,
  props: {
    color: String,
    valores: Array,
    label: String,
    thin: Boolean
  },
  methods: {
    formatAxis: function(label) {
      return new Date(
        parseInt(label) + new Date(this.valores[0].gap[0]).getTime()
      )
        .toLocaleTimeString()
        .substring(0, 5);
    },
    max: function() {
      return (
        new Date(
          moment()
            .add(1, "hour")
            .minute(0)
        ) - new Date(this.valores[0].gap[0])
      );
    },
    min: function() {
      return (
        new Date(
          moment()
            .add(1, "hour")
            .minute(0)
            .subtract(1, "day")
            .format()
        ) - new Date(this.valores[0].gap[0])
      );
    },
    getColorByStatus: function(status) {
      switch (status) {
        case "Produção":
          return "#388e3c";
        case "Parada":
          return "#b71c1c";
        case "Em Setup":
          return "#20c997";
        case "Ocioso":
          return "#1e88e5";
      }
    }
  },
  data: function() {
    return {
      datacollection: {
        datasets: this.valores.map(el => {
          const color = this.getColorByStatus(el.status);
          if (el.gap[0] > moment().format("YYYY-MM-DD[T]HH:mm:ss")) return {};
          return {
            data: [
              Math.min(new Date(), new Date(el.gap[1])) - new Date(el.gap[0])
            ],
            backgroundColor: color,
            hoverBackgroundColor: color
          };
        })
      },
      options: {
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: false,
                fontColor: "#f0f0f0",
                fontSize: 12,
                callback: this.formatAxis,
                min: this.min(),
                max: this.max(),
                stepSize: 2 * 60 * 60 * 1000
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            align: "center",
            color: "#f0f0f0",
            font: {
              size: "14"
            },
            formatter: function() {
              return "";
            }
          }
        }
      }
    };
  },
  mounted() {
    // this.chartData is created in the mixin
    this.renderChart(this.datacollection, this.options);
  }
};
